import {useAppSelector} from "../../store/hooks";
import {ApplicationVariant} from "../types/ApplicationVariant";

export const useApplicationVariant = () => {
    const modalApplicationVariant = useAppSelector((state) => state.mainLead.applicationVariant);

    return modalApplicationVariant ?? ApplicationVariant.DEFAULT;
};
import {useAppSelector} from "../../store/hooks";
import {ApplicationVariant} from "../types/ApplicationVariant";

export const useApplicationVariant = () => {
    const modalApplicationVariant = useAppSelector((state) => state.mainLead.applicationVariant);

    return modalApplicationVariant ?? ApplicationVariant.DEFAULT;
};
